// Redux Actions

// Dictionary
export const INIT_DICTIONARY = 'dictionary/INIT_DICTIONARY';

// Filter Bar
export const LIVE = 'LIVE';

// Get Standings
export const GET_STANDINGS_REQUEST = 'api/GET_STANDINGS_REQUEST';
export const GET_STANDINGS_SUCCESS = 'api/GET_STANDINGS_SUCCESS';
export const GET_STANDINGS_ERROR = 'api/GET_STANDINGS_ERROR';

// Get statistics
export const GET_STATISTICS = 'stats/GET_STATISTICS';
export const GET_LAST_MATCHES_REQUEST = 'api/GET_LAST_MATCHES_REQUEST';
export const GET_LAST_MATCHES_SUCCESS = 'api/GET_LAST_MATCHES_SUCCESS';
export const GET_LAST_MATCHES_ERROR = 'api/GET_LAST_MATCHES_ERROR';

// Get squad
export const GET_SQUAD_REQUEST = 'api/GET_SQUAD_REQUEST';
export const GET_SQUAD_SUCCESS = 'api/GET_SQUAD_SUCCESS';
export const GET_SQUAD_ERROR = 'api/GET_SQUAD_ERROR';

// Get Club Info
export const GET_CLUB_INFO_REQUEST = 'api/GET_CLUB_INFO_REQUEST';
export const GET_CLUB_INFO_SUCCESS = 'api/GET_CLUB_INFO_SUCCESS';
export const GET_CLUB_INFO_ERROR = 'api/GET_CLUB_INFO_ERROR';

// Get formazioni
export const GET_LINEUPS_REQUEST = 'api/GET_LINEUPS_REQUEST';
export const GET_LINEUPS_SUCCESS = 'api/GET_LINEUPS_SUCCESS';
export const GET_LINEUPS_ERROR = 'api/GET_LINEUPS_ERROR';
export const GET_MATCHINFO_SUCCESS = 'api/GET_MATCHINFO_SUCCESS';

export const GET_LINEUPS_BASKET_REQUEST = 'api/GET_LINEUPS_BASKET_REQUEST';
export const GET_LINEUPS_BASKET_SUCCESS = 'api/GET_LINEUPS_BASKET_SUCCESS';
export const GET_LINEUPS_BASKET_ERROR = 'api/GET_LINEUPS_BASKET_ERROR';

// Get Probabili formazioni
export const GET_PROBABILI_REQUEST = 'api/GET_PROBABILI_REQUEST';
export const GET_PROBABILI_SUCCESS = 'api/GET_PROBABILI_SUCCESS';
export const GET_PROBABILI_ERROR = 'api/GET_PROBABILI_ERROR';

// probabili request home
export const GET_PROBABILI_HOME_REQUEST = 'api/GET_PROBABILI_HOME_REQUEST';
export const GET_PROBABILI_HOME_SUCCESS = 'api/GET_PROBABILI_HOME_SUCCESS';
export const GET_PROBABILI_HOME_ERROR = 'api/GET_PROBABILI_HOME_ERROR';

// probabili request away
export const GET_PROBABILI_AWAY_REQUEST = 'api/GET_PROBABILI_AWAY_REQUEST';
export const GET_PROBABILI_AWAY_SUCCESS = 'api/GET_PROBABILI_AWAY_SUCCESS';
export const GET_PROBABILI_AWAY_ERROR = 'api/GET_PROBABILI_AWAY_ERROR';

// Get Global Info
export const GET_HEADER_INFO_REQUEST = 'api/GET_HEADER_INFO_REQUEST';
export const GET_HEADER_INFO_SUCCESS = 'api/GET_HEADER_INFO_SUCCESS';
export const GET_HEADER_INFO_ERROR = 'api/GET_HEADER_INFO_ERROR';

// Get Team Calendar
export const GET_TEAM_CALENDAR_REQUEST = 'api/GET_TEAM_CALENDAR_REQUEST';
export const GET_TEAM_CALENDAR_SUCCESS = 'api/GET_TEAM_CALENDAR_SUCCESS';
export const GET_TEAM_CALENDAR_ERROR = 'api/GET_TEAM_CALENDAR_ERROR';

//Local Storage
export const CLEAR_LOCAL_STORAGE = 'localStorage/CLEAR_LOCAL_STORAGE';
export const SET_LOCAL_STORAGE_DATE = 'locaStorage/SET_LOCAL_STORAGE_DATE';
export const UPDATE_LOCAL_STORAGE = 'localStorage/UPDATE_LOCAL_STORAGE';

// Table Types
export const TYPE_HUB = 'HUB';
export const TYPE_PREFERRED = 'PREFERRED';

// Timing Tag
export const PREMATCH = 'PreMatch';
export const FULLTIME = 'FullTime';
export const ABANDONED = 'Abandoned';
export const POSTPONED = 'Postponed';
export const DELAYED = 'Delayed';
export const SUSPENDED = 'Suspended';
export const HALFTIME = 'HalfTime';
export const FIRSTHALF = 'FirstHalf';
export const SECONDHALF = 'SecondHalf';
export const EXTRAHALFTIME = 'ExtraHalfTime';
export const EXTRAFIRSTHALF = 'ExtraFirstHalf';
export const EXTRASECONDHALF = 'ExtraSecondHalf';

// Match Status
export const PREMATCH_STATUS = 'PREMATCH';
export const POSTPONED_STATUS = 'POSTPONED';
export const LIVE_STATUS = 'LIVE';



// WEBPACK FOOTER //
// ./src/lib/constants/index.js